import React, { Component, ErrorInfo, ReactNode } from 'react'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div className="card" style={{ margin: '20px', textAlign: 'center' }}>
            <h2 style={{ color: '#e74c3c', marginBottom: '16px' }}>
              Something went wrong
            </h2>
            <p style={{ marginBottom: '20px', color: '#666' }}>
              We're sorry, but something unexpected happened. Please try refreshing the page.
            </p>
            <button 
              className="button primary"
              onClick={() => window.location.reload()}
            >
              Refresh Page
            </button>
            <details style={{ marginTop: '20px', textAlign: 'left' }}>
              <summary style={{ cursor: 'pointer', padding: '8px 0' }}>
                Technical Details (click to expand)
              </summary>
              <pre style={{ 
                background: '#f5f5f5', 
                padding: '12px', 
                borderRadius: '4px', 
                fontSize: '12px',
                overflow: 'auto',
                marginTop: '8px'
              }}>
                {this.state.error?.stack}
              </pre>
            </details>
          </div>
        )
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary